<template>
  <transition name="fade">
    <div class="text-center section">
        <v-calendar
          class="custom-calendar max-w-full"
          :masks="masks"
          :attributes="state.attributes"
          is-expanded
        >
          <template v-slot:day-content="{ day, attributes }">
            <div class="flex flex-col h-full z-10" style="overflow: auto; height: 100%;">
              <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
              <div class="flex-grow overflow-y-auto overflow-x-auto">
                <template v-for="attr in attributes" :key="attr.key">
                  <el-tooltip :content="attr.customData.tooltip" placement="top" effect="light" :show-after="500">
                    <a 
                      @click="clickTicket(attr.customData.item)"
                      class="btn btn-sm btn-light me-2 mb-1" style="text-align:left; width: 100%;overflow: hidden; white-space: nowrap; height: 26px; padding: 5px; font-size: 0.785em; border-radius:0px; color: black">
                         <i class="fas fa-square fs-5 me-0" :style="`color: #${attr.customData.item.color}`"></i>
                        {{ `${ attr.customData.title ? attr.customData.title : $t('Ticket') + ' #'+  attr.customData.item.tic_seq }` }}
                    </a>
                  </el-tooltip>
                </template>
              </div>
            </div>
          </template>
        </v-calendar>
      </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import mAxiosApi from "@/api";
import * as moment from "moment";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "kt-activite",
  props: {
    widgetClasses: String,
    myList: {default : [] as any },
    mField: String,
  },
  emits: ["affTicket"],
  setup(props, { emit }) {

  //moment.default.locale("fr");

    const state = reactive({
      list: [] as any,
      loaderEnabled: true,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      masks: {
        weekdays: 'WWWW',
      },
      attributes: [] as any,

    });
    const { t } = useI18n()

    const zmyList = props.myList as any;
    const zmField = props.mField as any;

    const clickTicket = (data) => {
      //console.log(data)
      emit("affTicket", data);
    }

    onMounted(async () => {



      zmyList.forEach(
        function(item: any){
          if(item.tis_date_planif || item.liv_date_liv) {
            // console.log(item.tis_date_planif, moment.default(item.tis_date_planif).toDate())
            state.attributes.push(
              {
                key: item.tis_seq,
                customData: {
                  title: ""+item.tic_c_label + "",
                  item: item,
                  tooltip: t("Ticket") + " #"+item.tic_seq +" - " + t("Libellé :") + " " +item.tic_c_label,
                },
                dates: item.tis_date_planif ? moment.default(item.tis_date_planif).toDate() : moment.default(item.liv_date_liv).toDate(),
              },
            )

          }


        }
      );
      
      state.loaderEnabled = false;
    });


    return {
      state,
      clickTicket,zmyList
    };
  },
});
</script>


